// extracted by mini-css-extract-plugin
export var deleteModal = "_gn-0";